<template>
  <div
    style="
      min-height: 100dvh;
      display: flex;
      flex-direction: column;
      justify-content: center;
    "
  >
    <a-row :gutter="[24, 24]" justify="center" align="middle">
      <a-col :span="24" style="text-align: center">
        <img
          style="max-width: 400px"
          class="img-fluid"
          src="@/assets/images/new-identity/logoBewell.svg"
          alt=""
        />
      </a-col>
      <a-col :span="24" style="text-align: center; max-width: 600px">
        <a-typography-title :level="1">
          Usa AlexIA ahora en WhatsApp
        </a-typography-title>
        <a-typography-title :level="4">
          Tu asistente inteligente para seguros.
        </a-typography-title>
        <p>
          Chatea con AlexIA para resolver tus dudas y recibir ayuda al instante.
        </p>
        <p>
          Si es necesario, un ejecutivo continuará la conversación para
          brindarte atención personalizada.
        </p>
      </a-col>
      <a-col :span="24" style="text-align: center">
        <a-button href="https://wa.me/56965900377" type="primary">
          Abrir en WhatsApp
        </a-button>
      </a-col>
    </a-row>
  </div>
</template>
